import React from 'react'
import About from './About'

const AboutPage = () => {
  return (
    <div style={{ paddingTop : '10vw'}}><About/></div>
  )
}

export default AboutPage